import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiGetBroker, getApiBase } from "../api";
import { useAuth } from "../components/AuthContext";

function section(title, children) {
  return (
    <div style={{ marginTop: 18, padding: 16, border: "1px solid #e5e5e5", borderRadius: 12, background: "white" }}>
      <div style={{ fontWeight: 900, marginBottom: 10 }}>{title}</div>
      {children}
    </div>
  );
}

export default function BrokerDashboard() {
  const nav = useNavigate();
  const apiBase = useMemo(() => getApiBase(), []);
  const { adminEmail } = useAuth();

  const [counts, setCounts] = useState({ all: 0, posted: 0, tendered: 0, pendingDocs: 0 });
  const [err, setErr] = useState("");

  useEffect(() => {
    async function run() {
      setErr("");
      try {
        const loads = await apiGetBroker("/broker/loads", { adminEmail });
        const docs = await apiGetBroker("/broker/documents/pending", { adminEmail });
        const ls = loads.loads || [];
        setCounts({
          all: ls.length,
          posted: ls.filter((l) => l.status === "POSTED").length,
          tendered: ls.filter((l) => l.status === "TENDERED").length,
          pendingDocs: (docs.documents || []).length,
        });
      } catch (e) {
        setErr(e.message || String(e));
      }
    }
    run();
  }, [adminEmail]);

  return (
    <div style={{ maxWidth: 1200 }}>
      <div style={{ fontSize: 12, color: "#666" }}>API: {apiBase}</div>

      {err ? (
        <div style={{ marginTop: 14, padding: 12, background: "#ffecec", border: "1px solid #ffb3b3", borderRadius: 10 }}>
          {err}
        </div>
      ) : null}

      {section(
        "Quick Actions",
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <button onClick={() => nav("/app/broker/create")} style={{ padding: "10px 14px", fontWeight: 900 }}>
            + Create Load
          </button>
          <button onClick={() => nav("/app/broker/loads")} style={{ padding: "10px 14px", fontWeight: 900 }}>
            View Loads
          </button>
          <button onClick={() => nav("/app/broker/customers")} style={{ padding: "10px 14px", fontWeight: 900 }}>
            Manage Shippers
          </button>
          <button onClick={() => nav("/app/broker/documents/pending")} style={{ padding: "10px 14px", fontWeight: 900 }}>
            Pending Documents
          </button>
        </div>
      )}

      {section(
        "Snapshot",
        <div style={{ display: "grid", gap: 8 }}>
          <div><b>Total loads:</b> {counts.all}</div>
          <div><b>Posted:</b> {counts.posted}</div>
          <div><b>Tendered:</b> {counts.tendered}</div>
          <div><b>Pending docs:</b> {counts.pendingDocs}</div>
        </div>
      )}
    </div>
  );
}
